import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Divider,
  Button,
  TextField,
  Grid
} from '@material-ui/core';
import axios from 'axios';
import { API_LOCAL } from '../../../../constants'; 
const useStyles = makeStyles(() => ({
  root: {}
}));

const Password = props => {
  const { className, ...rest } = props;

  const data = props;

  const classes = useStyles();

  const [values, setValues] = useState({
    password: '',
    confirm: ''
  });

  const [error, setError] = useState();


  const updatePassword = async() => {
    if(values.password.length == 0 || values.password != values.confirm){
      setError("Passwords don't match!")
      return;
    }
    const headers = {
      'token': localStorage.getItem('token')
    }
    const url = (API_LOCAL) + 'users/password/update';
 
    try {
      const result = await axios.post(url, { values }, { headers });
      
      if(result && result.data && result.data._id){
        setError("Password has been updated!")

        data.updateUser(result.data);
      }
      else {
        setError("Something went wrong...")
      }
    }
    catch(ex){
      console.log(ex);
    }
  }

  const handleChange = event => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  };

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <form>
        <CardHeader
          subheader="Update your password"
          title="Password"
        />

<Grid
            container
            spacing={3}
          >
             <Grid
              item
              md={12}
              xs={12}
            >
       {error }
      </Grid>
      </Grid>
        <Divider />
        <CardContent>
          <TextField
            fullWidth
            label="Password"
            name="password"
            onChange={handleChange}
            type="password"
            value={values.password}
            variant="outlined"
          />
          <TextField
            fullWidth
            label="Confirm password"
            name="confirm"
            onChange={handleChange}
            style={{ marginTop: '1rem' }}
            type="password"
            value={values.confirm}
            variant="outlined"
          />
        </CardContent>
        <Divider />
        <CardActions>
          <Button
            color="primary"
            variant="outlined"
            onClick={updatePassword}
          >
            Update
          </Button>
        </CardActions>
      </form>
    </Card>
  );
};

Password.propTypes = {
  className: PropTypes.string
};

export default Password;
